import { Button, Modal, createCssVariableString } from "best-common-react";
import React from "react";
import styled from "styled-components";
import CreditCardMappings from "../../constants/CreditCardMappings";
import { CreditCardIcon } from "./CreditCard";

const CardInfo = styled.div.attrs(() => ({
  className: "bcr-mt-2 bcr-p-2",
}))`
  border: 1px solid ${createCssVariableString("surfaceColorsSurfaceContainerHigh")};
  background: ${createCssVariableString("surfaceColorsSurfaceContainerLow")};
`;

const DeleteCreditCardModal = ({ show, ccType, ccNickname, ccLast4, onClose, onDelete, loading }) => (
  <>
    {show && (
      <Modal show={show}>
        <Modal.Header close={onClose}>Delete Credit Card</Modal.Header>
        <Modal.Body>
          Are you sure you want to delete the following credit card?
          <CardInfo>
            <div className="d-flex align-items-center">
              <CreditCardIcon type={CreditCardMappings[ccType.ccTypeName]} />{" "}
              <span className="bcr-ms-2">
                {ccNickname} ending in {ccLast4}
              </span>
            </div>
          </CardInfo>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" className="bcr-me-2" onClick={onDelete} loading={loading}>
            Delete
          </Button>
          <Button variant="default" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    )}
  </>
);

export default DeleteCreditCardModal;
